import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteHerausgeberCommandServiceModule } from '..';
import { DeleteHerausgeberCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    DeleteHerausgeberCommandServiceModule
  ],
  declarations: [DeleteHerausgeberCommandComponent],
  exports: [DeleteHerausgeberCommandComponent],

})
export class DeleteHerausgeberCommandComponentModule { }
